module.exports = __webpack_public_path__ + "Bg_reports_Spring.8f677db1e63c101facde7df0fa864dd3.png";